(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drbali-header"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('drbali-premium-header-v3')) {
    class DrBaliPremiumHeaderV3 extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-drbali-header-v3]');
        if (!this.root) return;

        this.megas = [...this.querySelectorAll('[data-drbali-mega]')];
        this.backdrop = this.querySelector('[data-drbali-menu-backdrop]');
        this.mobileMenu = this.querySelector('[data-drbali-mobile-menu]');
        this.mobileToggle = this.querySelector('[data-drbali-mobile-toggle]');
        this.mobileClose = this.querySelector('[data-drbali-mobile-close]');

        this.ticking = false;
        this.lastMobileFocus = null;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this.updateScrollState();

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);

        this.megas.forEach((details) => {
          details.addEventListener('toggle', () => {
            if (details.open) {
              this.megas.forEach((other) => {
                if (other !== details) other.open = false;
              });
            }

            this.syncMegaState();
          });
        });

        this.backdrop?.addEventListener('click', () => this.closeAllMegas());
        this.mobileToggle?.addEventListener('click', () => this.openMobileMenu());
        this.mobileClose?.addEventListener('click', () => this.closeMobileMenu());
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
      }

      handleScroll() {
        if (this.ticking) return;

        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateScrollState();
          this.ticking = false;
        });
      }

      updateScrollState() {
        this.root.dataset.scrolled = window.scrollY > 16 ? 'true' : 'false';
      }

      syncMegaState() {
        const open = this.megas.some((details) => details.open);
        this.root.dataset.menuOpen = open ? 'true' : 'false';
      }

      closeAllMegas() {
        this.megas.forEach((details) => {
          details.open = false;
        });
        this.root.dataset.menuOpen = 'false';
      }

      openMobileMenu() {
        this.lastMobileFocus = document.activeElement;
        this.closeAllMegas();

        this.root.dataset.mobileOpen = 'true';
        this.mobileMenu?.setAttribute('aria-hidden', 'false');
        this.mobileToggle?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(() => {
          this.mobileClose?.focus({ preventScroll: true });
        });
      }

      closeMobileMenu() {
        this.root.dataset.mobileOpen = 'false';
        this.mobileMenu?.setAttribute('aria-hidden', 'true');
        this.mobileToggle?.setAttribute('aria-expanded', 'false');
        document.body.style.removeProperty('overflow');

        if (this.lastMobileFocus && typeof this.lastMobileFocus.focus === 'function') {
          this.lastMobileFocus.focus({ preventScroll: true });
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          if (this.root.dataset.mobileOpen === 'true') {
            event.preventDefault();
            this.closeMobileMenu();
            return;
          }

          if (this.root.dataset.menuOpen === 'true') {
            event.preventDefault();
            this.closeAllMegas();
          }
        }

        if (event.key === 'Tab' && this.root.dataset.mobileOpen === 'true') {
          this.trapMobileFocus(event);
        }
      }

      trapMobileFocus(event) {
        if (!this.mobileMenu) return;

        const focusable = [...this.mobileMenu.querySelectorAll(
          'button:not([disabled]), a[href], summary, input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter((element) => element.offsetParent !== null);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleDocumentClick(event) {
        const searchTrigger = event.target.closest('[data-drbali-search-open]');
        if (searchTrigger && this.root.dataset.mobileOpen === 'true') {
          this.closeMobileMenu();
          return;
        }

        if (this.root.dataset.menuOpen !== 'true') return;
        if (event.target.closest('[data-drbali-mega]')) return;

        this.closeAllMegas();
      }
    }

    customElements.define('drbali-premium-header-v3', DrBaliPremiumHeaderV3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('drbali-hero')) {
  class DrBaliHero extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.viewport = this.querySelector('[data-hero-viewport]');
      this.prevButton = this.querySelector('[data-hero-prev]');
      this.nextButton = this.querySelector('[data-hero-next]');
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.progress = this.querySelector('[data-hero-progress]');

      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayConfigured = this.dataset.autoplay === 'true';
      this.speed = Number(this.dataset.speed) || 7000;
      this.transitionDuration = Number(this.dataset.transitionDuration) || 900;

      this.timer = null;
      this.startedAt = 0;
      this.remaining = this.speed;
      this.isTransitioning = false;
      this.pauseReasons = new Set();
      this.abortController = new AbortController();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.touchStartX = null;
      this.touchStartY = null;

      const signal = this.abortController.signal;

      this.prevButton?.addEventListener('click', () => this.changeBy(-1, 'user'), { signal });
      this.nextButton?.addEventListener('click', () => this.changeBy(1, 'user'), { signal });
      this.pauseButton?.addEventListener('click', () => this.toggleManualPause(), { signal });


      this.addEventListener('focusin', () => this.addPauseReason('focus'), { signal });
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.removePauseReason('focus');
      }, { signal });

      this.viewport?.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
      this.viewport?.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
      this.viewport?.addEventListener('pointercancel', () => this.cancelGesture(), { signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.addPauseReason('hidden');
        else this.removePauseReason('hidden');
      }, { signal });

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', (event) => this.onSectionSelect(event), { signal });
        document.addEventListener('shopify:section:deselect', (event) => this.onSectionDeselect(event), { signal });
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        document.addEventListener('shopify:block:deselect', (event) => this.onBlockDeselect(event), { signal });
      }

      this.motionChangeHandler = () => this.onReducedMotionChange();
      this.reducedMotion.addEventListener?.('change', this.motionChangeHandler);

      this.normalizeSlides();
      this.preloadAdjacentSlides();
      this.onReducedMotionChange();
      this.updatePauseButton();
      this.classList.add('is-ready');

      if (this.slides.length > 1) {
        if (this.canAutoplay()) this.restartCycle();
        else this.updateStaticProgress();
      }
    }

    disconnectedCallback() {
      this.clearTimer(false);
      this.abortController?.abort();
      this.reducedMotion?.removeEventListener?.('change', this.motionChangeHandler);
      this.dataset.initialized = 'false';
    }

    normalizeSlides() {
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.classList.remove(
          'is-entering',
          'is-leaving',
          'is-entering-from-right',
          'is-entering-from-left',
          'is-leaving-to-left',
          'is-leaving-to-right'
        );
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });
    }

    prepareImage(image) {
      if (!image) return Promise.resolve(true);

      image.loading = 'eager';

      const waitForLoad = image.complete
        ? Promise.resolve(image.naturalWidth > 0)
        : new Promise((resolve) => {
            image.addEventListener('load', () => resolve(true), { once: true });
            image.addEventListener('error', () => resolve(false), { once: true });
          });

      return waitForLoad.then(async (loaded) => {
        if (!loaded || image.naturalWidth === 0) return false;

        if (typeof image.decode === 'function') {
          try {
            await image.decode();
          } catch (error) {
            /* Some browsers may reject decode even after load.
               naturalWidth remains the final readiness check. */
          }
        }

        return image.complete && image.naturalWidth > 0;
      });
    }

    async prepareSlide(index) {
      if (!this.slides.length) return false;

      const normalized =
        ((index % this.slides.length) + this.slides.length) % this.slides.length;

      const slide = this.slides[normalized];
      const images = Array.from(slide.querySelectorAll('img'));

      if (images.length === 0) return true;

      const results = await Promise.all(images.map((image) => this.prepareImage(image)));
      return results.every(Boolean);
    }

    preloadAdjacentSlides() {
      if (this.slides.length < 2) return;

      this.prepareSlide(this.currentIndex + 1).catch(() => {});
      this.prepareSlide(this.currentIndex - 1).catch(() => {});
    }

    canAutoplay() {
      return (
        this.autoplayConfigured &&
        this.slides.length > 1 &&
        !this.reducedMotion.matches &&
        this.pauseReasons.size === 0
      );
    }

    addPauseReason(reason) {
      if (this.pauseReasons.has(reason)) return;
      this.pauseReasons.add(reason);
      this.pauseTimer();
      this.pauseProgress();
      this.updateLiveRegion();
    }

    removePauseReason(reason) {
      if (!this.pauseReasons.has(reason)) return;
      this.pauseReasons.delete(reason);

      if (this.canAutoplay()) {
        this.resumeProgress();
        this.scheduleTimer();
      }

      this.updateLiveRegion();
    }

    toggleManualPause() {
      if (this.pauseReasons.has('manual')) this.removePauseReason('manual');
      else this.addPauseReason('manual');

      this.updatePauseButton();
    }

    updatePauseButton() {
      if (!this.pauseButton) return;

      const manuallyPaused = this.pauseReasons.has('manual');
      const strings = window.accessibilityStrings || {};

      this.pauseButton.classList.toggle('is-manually-paused', manuallyPaused);
      this.pauseButton.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
      this.pauseButton.setAttribute(
        'aria-label',
        manuallyPaused
          ? (strings.playSlideshow || 'Play slideshow')
          : (strings.pauseSlideshow || 'Pause slideshow')
      );
    }

    updateLiveRegion() {
      if (!this.viewport) return;
      this.viewport.setAttribute('aria-live', this.canAutoplay() ? 'off' : 'polite');
    }

    onReducedMotionChange() {
      const reduced = this.reducedMotion.matches;
      this.dataset.reducedMotion = reduced ? 'true' : 'false';

      if (reduced) {
        this.clearTimer(false);
        this.stopProgressAnimation();
        this.updateStaticProgress();
      } else if (this.canAutoplay()) {
        this.restartCycle();
      }

      this.updateLiveRegion();
    }

    async changeBy(delta) {
      const target = this.currentIndex + delta;
      const direction = delta > 0 ? 'next' : 'previous';

      const changed = await this.showSlide(target, direction, false);
      if (changed) this.restartCycle();
    }

    async showSlide(index, direction = 'next', immediate = false) {
      if (this.slides.length < 2 && index === this.currentIndex) return false;
      if (this.isTransitioning && !immediate) return false;

      const total = this.slides.length;
      const normalized = ((index % total) + total) % total;

      if (normalized === this.currentIndex) {
        if (immediate) this.normalizeSlides();
        return false;
      }

      const current = this.slides[this.currentIndex];
      const next = this.slides[normalized];

      if (immediate || this.reducedMotion.matches) {
        this.prepareSlide(normalized).catch(() => {});
        this.currentIndex = normalized;
        this.preloadAdjacentSlides();
        this.normalizeSlides();
        this.updateStaticProgress();
        return true;
      }

      /* Lock interaction while the next slide is being prepared.
         The current slide remains fully visible until every image in the
         target slide has loaded and decoded, so the viewport background
         can never flash between slides. */
      this.isTransitioning = true;

      const nextIsReady = await this.prepareSlide(normalized);

      if (!nextIsReady) {
        this.isTransitioning = false;
        return false;
      }

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      current.inert = true;

      next.classList.add('is-active', 'is-entering');
      next.setAttribute('aria-hidden', 'false');
      next.inert = false;

      if (direction === 'previous') {
        current.classList.add('is-leaving-to-right');
        next.classList.add('is-entering-from-left');
      } else {
        current.classList.add('is-leaving-to-left');
        next.classList.add('is-entering-from-right');
      }

      this.currentIndex = normalized;
      this.preloadAdjacentSlides();

      window.setTimeout(() => {
        current.classList.remove('is-leaving', 'is-leaving-to-left', 'is-leaving-to-right');
        next.classList.remove('is-entering', 'is-entering-from-left', 'is-entering-from-right');
        this.isTransitioning = false;
      }, this.transitionDuration + 40);

      return true;
    }

    restartCycle() {
      if (this.slides.length < 2) return;

      this.clearTimer(false);
      this.remaining = this.speed;

      if (this.autoplayConfigured && !this.reducedMotion.matches) {
        this.restartProgress();

        if (this.canAutoplay()) this.scheduleTimer();
        else this.pauseProgress();
      } else {
        this.updateStaticProgress();
      }
    }

    scheduleTimer() {
      if (!this.canAutoplay() || this.timer) return;

      if (!this.remaining || this.remaining <= 0) this.remaining = this.speed;

      this.startedAt = performance.now();
      this.timer = window.setTimeout(async () => {
        this.timer = null;
        this.remaining = this.speed;

        const changed = await this.showSlide(this.currentIndex + 1, 'next', false);
        if (changed) this.restartCycle();
        else this.scheduleTimer();
      }, this.remaining);
    }

    pauseTimer() {
      if (!this.timer) return;

      window.clearTimeout(this.timer);
      this.timer = null;

      const elapsed = performance.now() - this.startedAt;
      this.remaining = Math.max(0, this.remaining - elapsed);
    }

    clearTimer(preserveRemaining = false) {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
      this.startedAt = 0;

      if (!preserveRemaining) this.remaining = this.speed;
    }

    restartProgress() {
      if (!this.progress) return;

      this.progress.classList.remove('is-running');
      this.progress.style.animationPlayState = 'running';
      this.progress.style.removeProperty('transform');
      this.progress.style.setProperty('--drbali-hero-progress-duration', `${this.speed}ms`);

      void this.progress.offsetWidth;
      this.progress.classList.add('is-running');
    }

    pauseProgress() {
      if (!this.progress?.classList.contains('is-running')) return;
      this.progress.style.animationPlayState = 'paused';
    }

    resumeProgress() {
      if (!this.progress?.classList.contains('is-running')) return;
      this.progress.style.animationPlayState = 'running';
    }

    stopProgressAnimation() {
      if (!this.progress) return;
      this.progress.classList.remove('is-running');
      this.progress.style.animationPlayState = 'paused';
    }

    updateStaticProgress() {
      if (!this.progress || this.slides.length === 0) return;

      this.stopProgressAnimation();
      const fraction = (this.currentIndex + 1) / this.slides.length;
      this.progress.style.transform = `scaleX(${fraction})`;
    }

    onPointerDown(event) {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

      this.touchStartX = event.clientX;
      this.touchStartY = event.clientY;
      this.addPauseReason('gesture');
    }

    onPointerUp(event) {
      if (this.touchStartX === null || this.touchStartY === null) return;

      const deltaX = event.clientX - this.touchStartX;
      const deltaY = event.clientY - this.touchStartY;

      this.touchStartX = null;
      this.touchStartY = null;

      const horizontalSwipe = Math.abs(deltaX) >= 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

      if (horizontalSwipe) this.changeBy(deltaX < 0 ? 1 : -1);
      this.removePauseReason('gesture');
    }

    cancelGesture() {
      this.touchStartX = null;
      this.touchStartY = null;
      this.removePauseReason('gesture');
    }

    onSectionSelect(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;
      this.addPauseReason('editor');
    }

    onSectionDeselect(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;
      this.removePauseReason('editor');
    }

    onBlockSelect(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;

      this.addPauseReason('editor');

      const selectedSlide = this.slides.find((slide) => slide.dataset.blockId === event.detail.blockId);
      if (!selectedSlide) return;

      const index = Number(selectedSlide.dataset.index);
      if (Number.isNaN(index)) return;

      this.showSlide(index, 'next', true);
      this.remaining = this.speed;
      this.updateStaticProgress();
    }

    onBlockDeselect(event) {
      if (event.detail?.sectionId !== this.dataset.sectionId) return;
      this.removePauseReason('editor');
    }
  }

  customElements.define('drbali-hero', DrBaliHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-layering-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drbali-layering-guide')) return;

    class DrBaliLayeringGuide extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-drbali-layering]') || this;
        this.tabs = [...this.querySelectorAll('[data-drbali-layering-tab]')];
        this.visuals = [...this.querySelectorAll('[data-drbali-layering-visual]')];
        this.details = [...this.querySelectorAll('[data-drbali-layering-detail]')];
        this.currentIndex = 0;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, true));

          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
              return;
            }

            event.preventDefault();

            let nextIndex = index;

            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              nextIndex = (index + 1) % this.tabs.length;
            }
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            }

            this.select(nextIndex, true);
            this.tabs[nextIndex]?.focus({ preventScroll: true });
          });
        });

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const selectedVisual = event.target.closest('[data-drbali-layering-visual]');
            if (!selectedVisual) return;

            const index = Number(selectedVisual.dataset.index);
            if (!Number.isNaN(index)) this.select(index, false);
          });
        }
      }

      select(index, scrollTab = false) {
        if (index < 0 || index >= this.tabs.length) return;
        this.currentIndex = index;

        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        this.visuals.forEach((visual, visualIndex) => {
          const active = visualIndex === index;

          if (active) {
            visual.hidden = false;
            window.requestAnimationFrame(() => {
              visual.classList.add('is-active');
            });
          } else {
            visual.classList.remove('is-active');
            visual.hidden = true;
          }
        });

        this.details.forEach((detail, detailIndex) => {
          const active = detailIndex === index;
          detail.classList.toggle('is-active', active);
          detail.hidden = !active;
        });

        if (scrollTab && window.matchMedia('(max-width: 989px)').matches) {
          this.tabs[index]?.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      }
    }

    customElements.define('drbali-layering-guide', DrBaliLayeringGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-routine-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drbali-routine-quiz')) return;

    class DrBaliRoutineQuiz extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-drbali-quiz]') || this;
        this.questions = [...this.querySelectorAll('[data-drbali-quiz-question]')];
        this.answers = [...this.querySelectorAll('[data-drbali-quiz-answer]')];
        this.resultsWrap = this.querySelector('[data-drbali-quiz-results]');
        this.resultPanels = [...this.querySelectorAll('[data-drbali-quiz-result]')];
        this.fallback = this.querySelector('[data-drbali-quiz-fallback]');
        this.loading = this.querySelector('[data-drbali-quiz-loading]');
        this.progress = this.querySelector('[data-drbali-quiz-progress]');
        this.progressBar = this.querySelector('[data-drbali-quiz-progress-bar]');
        this.progressLabel = this.querySelector('[data-drbali-quiz-progress-label]');
        this.nextButton = this.querySelector('[data-drbali-quiz-next]');
        this.backButton = this.querySelector('[data-drbali-quiz-back]');
        this.nav = this.querySelector('[data-drbali-quiz-nav]');
        this.resetButtons = [...this.querySelectorAll('[data-drbali-quiz-reset]')];

        this.current = 0;
        this.selected = {};
        this.scores = this.emptyScores();
        this.resultShown = false;

        this.answers.forEach((answer) => {
          answer.addEventListener('click', () => this.selectAnswer(answer));
        });

        this.nextButton?.addEventListener('click', () => this.next());
        this.backButton?.addEventListener('click', () => this.back());
        this.resetButtons.forEach((button) => {
          button.addEventListener('click', () => this.reset());
        });

        this.render();
      }

      emptyScores() {
        return {
          hydrate: 0,
          protect: 0,
          hair: 0,
          body: 0
        };
      }

      selectAnswer(answer) {
        const question = Number(answer.dataset.question);
        if (!question) return;

        const questionAnswers = this.answers.filter(
          (candidate) => Number(candidate.dataset.question) === question
        );

        questionAnswers.forEach((candidate) => {
          const selected = candidate === answer;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        this.selected[question] = {
          id: answer.dataset.answerId,
          hydrate: Number(answer.dataset.scoreHydrate || 0),
          protect: Number(answer.dataset.scoreProtect || 0),
          hair: Number(answer.dataset.scoreHair || 0),
          body: Number(answer.dataset.scoreBody || 0)
        };

        if (this.nextButton) this.nextButton.disabled = false;
      }

      next() {
        const questionNumber = this.current + 1;
        if (!this.selected[questionNumber]) return;

        if (this.current < this.questions.length - 1) {
          this.current += 1;
          this.render();
          return;
        }

        this.showResult();
      }

      back() {
        if (this.resultShown) {
          this.resultShown = false;
          if (this.resultsWrap) this.resultsWrap.hidden = true;
          if (this.nav) this.nav.hidden = false;
          this.current = this.questions.length - 1;
          this.render();
          return;
        }

        if (this.current <= 0) return;
        this.current -= 1;
        this.render();
      }

      calculateScores() {
        this.scores = this.emptyScores();

        Object.values(this.selected).forEach((answer) => {
          this.scores.hydrate += answer.hydrate;
          this.scores.protect += answer.protect;
          this.scores.hair += answer.hair;
          this.scores.body += answer.body;
        });

        return this.scores;
      }

      winningProfile() {
        const scores = this.calculateScores();
        const order = ['hydrate', 'protect', 'hair', 'body'];

        return order.reduce((best, profile) => {
          if (scores[profile] > scores[best]) return profile;
          return best;
        }, order[0]);
      }

      showResult() {
        this.questions.forEach((question) => {
          question.hidden = true;
          question.classList.remove('is-active');
        });

        if (this.nav) this.nav.hidden = true;
        if (this.loading) this.loading.hidden = false;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.setTimeout(() => {
          if (this.loading) this.loading.hidden = true;

          const profile = this.winningProfile();
          let matched = false;

          if (this.resultsWrap) this.resultsWrap.hidden = false;

          this.resultPanels.forEach((panel) => {
            const active = panel.dataset.profile === profile;
            panel.hidden = !active;
            if (active) matched = true;
          });

          if (this.fallback) this.fallback.hidden = matched;
          this.resultShown = true;

          this.resetButtons.forEach((button) => {
            button.hidden = false;
          });

          this.resultsWrap?.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'nearest'
          });
        }, reducedMotion ? 1 : 700);
      }

      reset() {
        this.current = 0;
        this.selected = {};
        this.scores = this.emptyScores();
        this.resultShown = false;

        this.answers.forEach((answer) => {
          answer.classList.remove('is-selected');
          answer.setAttribute('aria-checked', 'false');
        });

        this.resultPanels.forEach((panel) => {
          panel.hidden = true;
        });

        if (this.fallback) this.fallback.hidden = true;
        if (this.resultsWrap) this.resultsWrap.hidden = true;
        if (this.loading) this.loading.hidden = true;
        if (this.nav) this.nav.hidden = false;

        this.resetButtons.forEach((button) => {
          if (button.closest('.drbali-quiz__topbar')) button.hidden = true;
        });

        this.render();
      }

      render() {
        this.questions.forEach((question, index) => {
          const active = index === this.current;
          question.hidden = !active;
          question.classList.toggle('is-active', active);
        });

        const questionNumber = this.current + 1;
        const hasSelection = Boolean(this.selected[questionNumber]);

        if (this.nextButton) {
          this.nextButton.disabled = !hasSelection;
          const label = this.nextButton.querySelector('span');
          if (label) {
            label.textContent =
              this.current === this.questions.length - 1
                ? 'Sonucu gör'
                : 'Devam et';
          }
        }

        if (this.backButton) {
          this.backButton.disabled = this.current === 0;
        }

        if (this.progressLabel) {
          this.progressLabel.textContent =
            `${String(questionNumber).padStart(2, '0')} / ${String(this.questions.length).padStart(2, '0')}`;
        }

        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', String(questionNumber));
        }

        if (this.progressBar) {
          const ratio = questionNumber / this.questions.length;
          this.progressBar.style.transform = `scaleX(${ratio})`;
        }

        const topReset = this.querySelector('.drbali-quiz__topbar [data-drbali-quiz-reset]');
        if (topReset) topReset.hidden = Object.keys(this.selected).length === 0;

        const currentQuestion = this.questions[this.current];
        const selectedAnswer = this.selected[questionNumber];

        if (selectedAnswer && currentQuestion) {
          const match = currentQuestion.querySelector(
            `[data-answer-id="${CSS.escape(selectedAnswer.id)}"]`
          );

          if (match) {
            match.classList.add('is-selected');
            match.setAttribute('aria-checked', 'true');
          }
        }
      }
    }

    customElements.define('drbali-routine-quiz', DrBaliRoutineQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-shoppable-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drbali-shoppable-look')) return;

    class DrBaliShoppableLook extends HTMLElement {
      connectedCallback() {
        this.hotspots = [...this.querySelectorAll('[data-drbali-hotspot]')];
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.hotspots.forEach((hotspot) => {
          const toggle = hotspot.querySelector('[data-drbali-hotspot-toggle]');
          const close = hotspot.querySelector('[data-drbali-hotspot-close]');
          const card = hotspot.querySelector('[data-drbali-hotspot-card]');

          toggle?.addEventListener('click', (event) => {
            event.stopPropagation();
            const shouldOpen = !hotspot.classList.contains('is-open');
            this.closeAll();
            if (shouldOpen) this.open(hotspot);
          });

          close?.addEventListener('click', (event) => {
            event.stopPropagation();
            this.close(hotspot, true);
          });

          /* Do not stop click propagation on the product card.
             DrBali Quick View listens at document level for
             [data-drbali-quick-view], so the click must bubble. */
        });

        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      open(hotspot) {
        const toggle = hotspot.querySelector('[data-drbali-hotspot-toggle]');
        const card = hotspot.querySelector('[data-drbali-hotspot-card]');
        if (!toggle || !card) return;
        card.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => hotspot.classList.add('is-open'));
      }

      close(hotspot, restoreFocus = false) {
        const toggle = hotspot.querySelector('[data-drbali-hotspot-toggle]');
        const card = hotspot.querySelector('[data-drbali-hotspot-card]');
        if (!toggle || !card) return;
        hotspot.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(() => {
          card.hidden = true;
          if (restoreFocus) toggle.focus({ preventScroll: true });
        }, reduced ? 1 : 230);
      }

      closeAll() {
        this.hotspots.forEach((hotspot) => {
          if (hotspot.classList.contains('is-open')) this.close(hotspot);
        });
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target) || !event.target.closest('[data-drbali-hotspot]')) this.closeAll();
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') return;
        const openHotspot = this.hotspots.find((hotspot) => hotspot.classList.contains('is-open'));
        if (!openHotspot) return;
        event.preventDefault();
        this.close(openHotspot, true);
      }
    }

    customElements.define('drbali-shoppable-look', DrBaliShoppableLook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-skin-analysis-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-analysis-root]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const engine = root.querySelector('[data-analysis-engine]');
    const engineWrap = root.querySelector('.drbali-analysis-v2__engine-wrap');
    const questions = [...root.querySelectorAll('[data-analysis-question]')];
    const answers = [...root.querySelectorAll('[data-analysis-answer]')];
    const startButtons = [...root.querySelectorAll('[data-analysis-start]')];
    const nextButton = root.querySelector('[data-analysis-next]');
    const backButton = root.querySelector('[data-analysis-back]');
    const nav = root.querySelector('[data-analysis-nav]');
    const progress = root.querySelector('[data-analysis-progress]');
    const progressBar = root.querySelector('[data-analysis-progress-bar]');
    const progressLabel = root.querySelector('[data-analysis-progress-label]');
    const result = root.querySelector('[data-analysis-result]');
    const success = root.querySelector('[data-analysis-success]');
    const form = root.querySelector('[data-analysis-email-form]');
    const formStatus = root.querySelector('[data-analysis-form-status]');

    const scoreEls = {
      oil: root.querySelector('[data-score-oil]'),
      hydration: root.querySelector('[data-score-hydration]'),
      sensitivity: root.querySelector('[data-score-sensitivity]'),
      protection: root.querySelector('[data-score-protection]')
    };

    const barEls = {
      oil: root.querySelector('[data-bar-oil]'),
      hydration: root.querySelector('[data-bar-hydration]'),
      sensitivity: root.querySelector('[data-bar-sensitivity]'),
      protection: root.querySelector('[data-bar-protection]')
    };

    let current = 0;
    let selected = {};
    let report = null;
    let sessionId = (window.crypto?.randomUUID?.() || `drbali-${Date.now()}-${Math.random().toString(16).slice(2)}`);

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const normalizeText = (value) => String(value || '').trim();

    const utmProperties = () => {
      const params = new URLSearchParams(window.location.search);
      return {
        drbali_utm_source: params.get('utm_source') || '',
        drbali_utm_medium: params.get('utm_medium') || '',
        drbali_utm_campaign: params.get('utm_campaign') || '',
        drbali_utm_content: params.get('utm_content') || '',
        drbali_utm_term: params.get('utm_term') || '',
        drbali_landing_path: window.location.pathname
      };
    };

    const maxScores = () => {
      const max = { oil: 0, hydration: 0, sensitivity: 0, protection: 0 };

      questions.forEach((question) => {
        const questionAnswers = [...question.querySelectorAll('[data-analysis-answer]')];
        const local = { oil: 0, hydration: 0, sensitivity: 0, protection: 0 };

        questionAnswers.forEach((answer) => {
          local.oil = Math.max(local.oil, Number(answer.dataset.oil || 0));
          local.hydration = Math.max(local.hydration, Number(answer.dataset.hydration || 0));
          local.sensitivity = Math.max(local.sensitivity, Number(answer.dataset.sensitivity || 0));
          local.protection = Math.max(local.protection, Number(answer.dataset.protection || 0));
        });

        Object.keys(max).forEach((key) => {
          max[key] += local[key];
        });
      });

      return max;
    };

    const recommendationCards = [...root.querySelectorAll('[data-analysis-rec-card]')];
    const recommendationWrap = root.querySelector('[data-analysis-recommendation]');
    const recommendationReason = root.querySelector('[data-analysis-recommendation-reason]');

    const chooseProductRecommendations = (analysisReport) => {
      const scores = analysisReport.scores || {};
      const props = analysisReport.properties || {};

      const weights = {
        hydration: 0,
        oil_balance: 0,
        even_appearance: 0,
        smoothness: 0,
        protection: 0,
        sensitivity: 0,
        balanced: 0
      };

      const qualified = new Set();
      const goal = props.drbali_answer_main_goal || props.drbali_main_goal || '';

      const goalMap = {
        hydration: 'hydration',
        oil_balance: 'oil_balance',
        even_appearance: 'even_appearance',
        smoothness: 'smoothness',
        protection: 'protection'
      };

      /* Explicit goal is the strongest commercial + relevance signal. */
      if (goalMap[goal]) {
        weights[goalMap[goal]] += goal === 'protection' ? 78 : 72;
        qualified.add(goalMap[goal]);
      }

      /* Four analysis dimensions. */
      weights.hydration += Number(scores.hydration || 0) * .60;
      weights.oil_balance += Number(scores.oil || 0) * .60;
      weights.sensitivity += Number(scores.sensitivity || 0) * .76;
      weights.protection += Number(scores.protection || 0) * .72;

      if (Number(scores.hydration || 0) >= 54) qualified.add('hydration');
      if (Number(scores.oil || 0) >= 54) qualified.add('oil_balance');
      if (Number(scores.sensitivity || 0) >= 48) qualified.add('sensitivity');
      if (Number(scores.protection || 0) >= 48) qualified.add('protection');

      /* Softer appearance dimensions only become standalone recommendations
         when the customer explicitly chose them as a goal. */
      weights.even_appearance +=
        Number(scores.hydration || 0) * .08 +
        Number(scores.protection || 0) * .14;

      weights.smoothness +=
        Number(scores.oil || 0) * .12 +
        Number(scores.hydration || 0) * .14;

      /* Skin profile tie-breakers. */
      if (analysisReport.type === 'dry') {
        weights.hydration += 24;
        qualified.add('hydration');
      } else if (analysisReport.type === 'balanced') {
        weights.balanced += 28;
      } else if (analysisReport.type === 'combination') {
        weights.oil_balance += 20;
        weights.hydration += 12;
      } else if (analysisReport.type === 'oily') {
        weights.oil_balance += 30;
        qualified.add('oil_balance');
      }

      const afterCleansing = props.drbali_answer_after_cleansing || '';
      if (afterCleansing === 'tight_dry') {
        weights.hydration += 18;
        qualified.add('hydration');
      }
      if (afterCleansing === 'tzone_shine') weights.oil_balance += 10;
      if (afterCleansing === 'oily_all') {
        weights.oil_balance += 16;
        qualified.add('oil_balance');
      }

      const shine = props.drbali_answer_daytime_shine || '';
      if (shine === 'tzone') weights.oil_balance += 8;
      if (shine === 'tzone_cheeks') {
        weights.oil_balance += 13;
        qualified.add('oil_balance');
      }
      if (shine === 'all_face') {
        weights.oil_balance += 18;
        qualified.add('oil_balance');
      }

      const pores = props.drbali_answer_pore_visibility || '';
      if (pores === 'tzone') weights.oil_balance += 7;
      if (pores === 'general') {
        weights.oil_balance += 11;
        qualified.add('oil_balance');
      }

      const dehydration = props.drbali_answer_dehydration_feel || '';
      if (dehydration === 'sometimes') weights.hydration += 6;
      if (dehydration === 'often') {
        weights.hydration += 13;
        qualified.add('hydration');
      }
      if (dehydration === 'very_often') {
        weights.hydration += 21;
        qualified.add('hydration');
      }

      const reactivity = props.drbali_answer_product_reactivity || '';
      if (reactivity === 'occasional') weights.sensitivity += 10;
      if (reactivity === 'frequent') {
        weights.sensitivity += 24;
        qualified.add('sensitivity');
      }
      if (reactivity === 'high') {
        weights.sensitivity += 36;
        qualified.add('sensitivity');
      }

      const spfHabit = props.drbali_answer_spf_habit || '';
      if (spfHabit === 'most_days') weights.protection += 5;
      if (spfHabit === 'summer_only') {
        weights.protection += 18;
        qualified.add('protection');
      }
      if (spfHabit === 'rarely') {
        weights.protection += 34;
        qualified.add('protection');
      }

      /*
        If the customer has no / one-step routine, surface one basic routine
        product as a lower-priority complement. This is not allowed to outrank
        the explicit goal.
      */
      const routineSteps = props.drbali_answer_routine_steps || '';
      if (routineSteps === 'none') {
        weights.balanced += 46;
        qualified.add('balanced');
      } else if (routineSteps === 'one') {
        weights.balanced += 34;
        qualified.add('balanced');
      }

      const highestNeed = Math.max(
        Number(scores.oil || 0),
        Number(scores.hydration || 0),
        Number(scores.sensitivity || 0),
        Number(scores.protection || 0)
      );

      if (qualified.size === 0 || (highestNeed < 45 && !goalMap[goal])) {
        weights.balanced += 38;
        qualified.add('balanced');
      }

      const availableCards = recommendationCards.filter(
        (card) => card.dataset.recKey && card.dataset.recUrl
      );

      const available = new Set(availableCards.map((card) => card.dataset.recKey));

      let ranked = Object.entries(weights)
        .filter(([key]) => available.has(key) && qualified.has(key))
        .sort((a, b) => b[1] - a[1]);

      /* Always return at least one existing product. */
      if (ranked.length === 0) {
        ranked = Object.entries(weights)
          .filter(([key]) => available.has(key))
          .sort((a, b) => b[1] - a[1]);
      }

      const reasonMap = {
        hydration: 'Nem ihtiyacı, gerginlik veya susuzluk sinyalleriniz bu ürünü öncelikli hale getiriyor.',
        oil_balance: 'Parlama, sebum ve gözenek görünümü yanıtlarınız yağ dengesi odaklı bu ürünü öne çıkarıyor.',
        even_appearance: 'Ana hedefiniz daha eşit ve canlı bir görünüm olduğu için bu ürün öneri listenizde üst sırada.',
        smoothness: 'Daha pürüzsüz bir his hedefiniz ve profil skorlarınız bu ürünü destekleyici seçenek olarak öne çıkarıyor.',
        protection: 'Günlük koruma hedefiniz ve SPF kullanım alışkanlığınız güneş bakımını önceliklendiriyor.',
        sensitivity: 'Ürün reaktivitesi ve hassasiyet eğilimi yanıtlarınız daha kontrollü bir rutin adımını öne çıkarıyor.',
        balanced: 'Rutininizin temelini daha düzenli kurabilmeniz için bu ürünü tamamlayıcı adım olarak ekledik.'
      };

      const picked = [];
      const seenUrls = new Set();

      for (const [key, score] of ranked) {
        const card = availableCards.find((item) => item.dataset.recKey === key);
        if (!card) continue;

        const url = card.dataset.recUrl || '';
        if (!url || seenUrls.has(url)) continue;

        const primaryScore = ranked[0]?.[1] || score;

        /*
          Product 1 is always shown.
          Product 2/3 are shown only when they are meaningful enough,
          so we don't turn every result into an indiscriminate product grid.
        */
        if (picked.length === 1 && score < Math.max(38, primaryScore * .34)) continue;
        if (picked.length === 2 && score < Math.max(48, primaryScore * .40)) continue;

        picked.push({
          key,
          score: Math.round(score || 0),
          reason: reasonMap[key] || '',
          title: card.dataset.recTitle || '',
          url
        });

        seenUrls.add(url);
        if (picked.length >= 3) break;
      }

      return picked;
    };

    const renderProductRecommendations = (analysisReport) => {
      if (!recommendationWrap || recommendationCards.length === 0) return [];

      const recommendations = chooseProductRecommendations(analysisReport);
      const selectedKeys = new Set(recommendations.map((item) => item.key));

      recommendationCards.forEach((card) => {
        const match = recommendations.find((item) => item.key === card.dataset.recKey);
        const index = match ? recommendations.indexOf(match) : -1;

        card.hidden = !match;
        card.classList.toggle('is-primary', index === 0);
        card.classList.toggle('is-secondary', index > 0);

        if (!match) {
          card.style.order = '';
          return;
        }

        const rank = card.querySelector('[data-rec-rank]');
        const reason = card.querySelector('[data-rec-reason]');

        if (rank) rank.textContent = String(index + 1).padStart(2, '0');
        if (reason) reason.textContent = match.reason;

        card.style.order = String(index);
      });

      if (recommendations.length === 0) {
        recommendationWrap.hidden = true;
        return [];
      }

      recommendationWrap.hidden = false;

      if (recommendationReason) {
        recommendationReason.textContent =
          recommendations.length > 1
            ? 'Yanıtlarınıza göre ihtiyaçlarınızı önem sırasına koyduk. İlk ürün ana hedefinize, diğerleri ise öne çıkan ek ihtiyaçlarınıza göre seçildi.'
            : 'Yanıtlarınıza göre bakım hedefinizle en çok örtüşen ürünü öne çıkarıyoruz.';
      }

      return recommendations;
    };

    const calculate = () => {
      const raw = { oil: 0, hydration: 0, sensitivity: 0, protection: 0 };
      const properties = {};

      Object.entries(selected).forEach(([index, item]) => {
        raw.oil += item.oil;
        raw.hydration += item.hydration;
        raw.sensitivity += item.sensitivity;
        raw.protection += item.protection;
        properties[`drbali_answer_${item.key}`] = item.value;
      });

      const max = maxScores();
      const scores = {};

      Object.keys(raw).forEach((key) => {
        scores[key] = max[key] > 0
          ? Math.round((raw[key] / max[key]) * 100)
          : 0;
      });

      let type = 'balanced';
      let typeLabel = 'Dengeli';

      if (scores.oil <= 30) {
        type = 'dry';
        typeLabel = 'Kuru';
      } else if (scores.oil <= 52) {
        type = 'balanced';
        typeLabel = 'Dengeli';
      } else if (scores.oil <= 73) {
        type = 'combination';
        typeLabel = 'Karma';
      } else {
        type = 'oily';
        typeLabel = 'Yağlı';
      }

      const needs = [];

      if (scores.hydration >= 58) {
        needs.push({ key: 'hydration', label: 'Nem İhtiyacı Yüksek', score: scores.hydration });
      }
      if (scores.sensitivity >= 55) {
        needs.push({ key: 'sensitivity', label: 'Hassasiyete Eğilimli', score: scores.sensitivity });
      }
      if (scores.protection >= 55) {
        needs.push({ key: 'protection', label: 'Koruma Öncelikli', score: scores.protection });
      }

      needs.sort((a, b) => b.score - a.score);

      const typeCopy = {
        dry: 'Yanıtlarınız cildinizin sebum üretiminin daha düşük ve nem konforu ihtiyacının daha belirgin olabileceğini düşündürüyor. Bakım yaklaşımında nazik temizleme ve nem desteği ön plana çıkabilir.',
        balanced: 'Yanıtlarınız sebum ve konfor açısından daha dengeli bir günlük cilt davranışına işaret ediyor. Bu profilde amaç mevcut dengeyi koruyan sade ve sürdürülebilir bir rutin kurmaktır.',
        combination: 'Yanıtlarınız özellikle T bölgesi ile diğer yüz bölgeleri arasında farklı davranışlar olabileceğini gösteriyor. Karma profilde bölgesel dengeyi korurken cildi gereksiz yere kurutmamak önemlidir.',
        oily: 'Yanıtlarınız gün içinde daha belirgin sebum ve parlama eğilimine işaret ediyor. Bakım yaklaşımında hafif dokular, düzenli temizleme ve bariyeri zorlamadan dengeyi desteklemek ön plana çıkabilir.'
      };

      const goal = properties.drbali_answer_main_goal || '';
      const routine = properties.drbali_answer_routine_preference || '';
      const spf = properties.drbali_answer_spf_habit || '';

      const profileLabel = [typeLabel, ...needs.slice(0, 2).map((item) => item.label)].join(' · ');

      return {
        sessionId,
        type,
        typeLabel,
        profileLabel,
        scores,
        needs,
        summary: typeCopy[type],
        properties: {
          ...properties,
          ...utmProperties(),
          drbali_analysis_version: '2.0',
          drbali_analysis_session_id: sessionId,
          drbali_skin_type: type,
          drbali_skin_type_label: typeLabel,
          drbali_skin_profile_label: profileLabel,
          drbali_oil_score: scores.oil,
          drbali_hydration_need_score: scores.hydration,
          drbali_sensitivity_score: scores.sensitivity,
          drbali_protection_need_score: scores.protection,
          drbali_main_goal: goal,
          drbali_routine_preference: routine,
          drbali_spf_habit: spf
        }
      };
    };

    const renderQuestion = () => {
      questions.forEach((question, index) => {
        question.hidden = index !== current;
        question.classList.toggle('is-active', index === current);
      });

      const number = current + 1;
      const total = questions.length;
      const ratio = total ? number / total : 0;

      if (progressLabel) {
        progressLabel.textContent = `${String(number).padStart(2,'0')} / ${String(total).padStart(2,'0')}`;
      }
      if (progress) {
        progress.setAttribute('aria-valuemax', String(total));
        progress.setAttribute('aria-valuenow', String(number));
      }
      if (progressBar) {
        progressBar.style.transform = `scaleX(${ratio})`;
      }

      if (backButton) backButton.disabled = current === 0;
      if (nextButton) {
        nextButton.disabled = !selected[current];
        const label = nextButton.querySelector('span');
        if (label) label.textContent = current === total - 1 ? 'Profilimi gör' : 'Devam et';
      }
    };

    const selectAnswer = (answer) => {
      const question = answer.closest('[data-analysis-question]');
      if (!question) return;

      const index = Number(question.dataset.index);
      const key = question.dataset.key || `question_${index + 1}`;

      question.querySelectorAll('[data-analysis-answer]').forEach((candidate) => {
        const active = candidate === answer;
        candidate.classList.toggle('is-selected', active);
        candidate.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      selected[index] = {
        key,
        value: normalizeText(answer.dataset.value),
        oil: Number(answer.dataset.oil || 0),
        hydration: Number(answer.dataset.hydration || 0),
        sensitivity: Number(answer.dataset.sensitivity || 0),
        protection: Number(answer.dataset.protection || 0)
      };

      if (nextButton) nextButton.disabled = false;
    };

    const renderResult = () => {
      report = calculate();

      questions.forEach((question) => {
        question.hidden = true;
      });
      if (nav) nav.hidden = true;
      result.hidden = false;
      success.hidden = true;

      const profile = root.querySelector('[data-result-profile]');
      const tags = root.querySelector('[data-result-tags]');
      const summary = root.querySelector('[data-result-summary]');
      const code = root.querySelector('[data-result-code]');

      if (profile) profile.textContent = report.profileLabel;
      if (summary) summary.textContent = report.summary;
      if (code) {
        const map = { dry: '01', balanced: '02', combination: '03', oily: '04' };
        code.textContent = map[report.type] || '00';
      }

      if (tags) {
        tags.innerHTML = '';
        const primary = document.createElement('span');
        primary.textContent = `${report.typeLabel} cilt profili`;
        tags.appendChild(primary);

        report.needs.forEach((item) => {
          const tag = document.createElement('span');
          tag.textContent = item.label;
          tags.appendChild(tag);
        });
      }

      Object.keys(scoreEls).forEach((key) => {
        if (scoreEls[key]) scoreEls[key].textContent = `${report.scores[key]}/100`;
        if (barEls[key]) {
          requestAnimationFrame(() => {
            barEls[key].style.transform = `scaleX(${report.scores[key] / 100})`;
          });
        }
      });

      const recommendations = renderProductRecommendations(report);

      if (recommendations.length) {
        report.recommendations = recommendations;
        report.recommendation = recommendations[0];

        report.properties.drbali_recommended_product_key = recommendations[0].key;
        report.properties.drbali_recommended_product_title = recommendations[0].title;
        report.properties.drbali_recommended_product_url = recommendations[0].url;
        report.properties.drbali_recommendation_score = recommendations[0].score;
        report.properties.drbali_recommended_products = recommendations
          .map((item) => item.title)
          .join(' | ');
      }

      document.dispatchEvent(new CustomEvent('drbali:skin-analysis-completed', {
        detail: report
      }));
    };

    const reset = () => {
      current = 0;
      selected = {};
      report = null;
      sessionId = (window.crypto?.randomUUID?.() || `drbali-${Date.now()}-${Math.random().toString(16).slice(2)}`);

      answers.forEach((answer) => {
        answer.classList.remove('is-selected');
        answer.setAttribute('aria-checked', 'false');
      });

      result.hidden = true;
      success.hidden = true;
      if (recommendationWrap) recommendationWrap.hidden = true;
      recommendationCards.forEach((card) => { card.hidden = true; });
      if (nav) nav.hidden = false;
      if (form) form.reset();
      if (formStatus) formStatus.textContent = '';

      renderQuestion();
    };

    const klaviyoPost = async (path, publicKey, payload) => {
      const response = await fetch(`https://a.klaviyo.com${path}?company_id=${encodeURIComponent(publicKey)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok && response.status !== 202) {
        let detail = '';
        try {
          const data = await response.json();
          detail = data?.errors?.[0]?.detail || '';
        } catch (error) {
          detail = '';
        }
        throw new Error(detail || `Klaviyo request failed (${response.status})`);
      }

      return response;
    };

    const createProfile = async (publicKey, email, firstName, properties) => {
      return klaviyoPost('/client/profiles', publicKey, {
        data: {
          type: 'profile',
          attributes: {
            email,
            first_name: firstName || null,
            locale: 'tr-TR',
            properties
          }
        }
      });
    };

    const createEvent = async (publicKey, email, firstName, eventName, properties) => {
      return klaviyoPost('/client/events', publicKey, {
        data: {
          type: 'event',
          attributes: {
            properties,
            unique_id: report?.sessionId || undefined,
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: eventName || 'DrBali Skin Analysis Completed'
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  first_name: firstName || null,
                  locale: 'tr-TR',
                  properties
                }
              }
            }
          }
        }
      });
    };

    const subscribeMarketing = async (publicKey, listId, email, firstName, properties) => {
      return klaviyoPost('/client/subscriptions', publicKey, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'DrBali Skin Profile Analysis V2',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  first_name: firstName || null,
                  locale: 'tr-TR',
                  properties,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      });
    };

    const submitReport = async (event) => {
      event.preventDefault();
      if (!report || !form) return;

      const emailInput = form.querySelector('input[name="email"]');
      const firstNameInput = form.querySelector('input[name="first_name"]');
      const consentInput = form.querySelector('input[name="marketing_consent"]');
      const submitButton = form.querySelector('button[type="submit"]');

      const email = normalizeText(emailInput?.value);
      const firstName = normalizeText(firstNameInput?.value);
      const marketingConsent = Boolean(consentInput?.checked);

      if (!email || !emailInput?.checkValidity()) {
        if (formStatus) formStatus.textContent = 'Geçerli bir e-posta adresi girin.';
        emailInput?.focus();
        return;
      }

      const enabled = root.dataset.klaviyoEnabled === 'true';
      const publicKey = normalizeText(root.dataset.klaviyoKey);
      const listId = normalizeText(root.dataset.klaviyoList);
      const eventName = normalizeText(root.dataset.klaviyoEvent) || 'DrBali Skin Analysis Completed';

      if (!enabled || !publicKey) {
        if (formStatus) {
          formStatus.textContent = 'E-posta raporu şu anda aktif değil. Cilt profiliniz ve skorlarınız bu ekranda görüntülenebilir.';
        }
        return;
      }

      if (marketingConsent && !listId) {
        if (formStatus) {
          formStatus.textContent = 'Pazarlama listesi için Klaviyo List ID henüz yapılandırılmamış.';
        }
        return;
      }

      const properties = {
        ...report.properties,
        drbali_report_requested: true,
        drbali_marketing_consent: marketingConsent
      };

      if (submitButton) submitButton.disabled = true;
      if (formStatus) formStatus.textContent = 'Rapor hazırlanıyor…';

      try {
        await createProfile(publicKey, email, firstName, properties);
        await createEvent(publicKey, email, firstName, eventName, properties);

        if (marketingConsent) {
          await subscribeMarketing(publicKey, listId, email, firstName, properties);
        }

        result.hidden = true;
        success.hidden = false;
        if (nav) nav.hidden = true;

        const successCopy = root.querySelector('[data-analysis-success-copy]');
        if (successCopy) {
          successCopy.textContent = marketingConsent
            ? 'Detaylı rapor talebiniz oluşturuldu ve DrBali pazarlama ileti izniniz kaydedildi.'
            : 'Detaylı rapor talebiniz oluşturuldu. Pazarlama ileti izni vermediğiniz için yalnızca rapor akışı için kullanılacaktır.';
        }

        document.dispatchEvent(new CustomEvent('drbali:skin-analysis-report-requested', {
          detail: {
            email,
            marketingConsent,
            ...report
          }
        }));

        if (marketingConsent) {
          document.dispatchEvent(new CustomEvent('drbali:marketing-consent', {
            detail: { source: 'skin_analysis_v2' }
          }));
        }
      } catch (error) {
        console.error('[DrBali Skin Analysis]', error);
        if (formStatus) {
          formStatus.textContent = 'Rapor talebi gönderilemedi. Lütfen kısa bir süre sonra tekrar deneyin.';
        }
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    };

    startButtons.forEach((button) => {
      button.addEventListener('click', () => {
        engineWrap?.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });

        window.setTimeout(() => {
          questions[0]?.querySelector('[data-analysis-answer]')?.focus({ preventScroll: true });
        }, reducedMotion() ? 1 : 500);
      });
    });

    answers.forEach((answer) => {
      answer.addEventListener('click', () => selectAnswer(answer));
    });

    nextButton?.addEventListener('click', () => {
      if (!selected[current]) return;

      if (current < questions.length - 1) {
        current += 1;
        renderQuestion();
        questions[current]?.querySelector('[data-analysis-answer]')?.focus({ preventScroll: true });
      } else {
        renderResult();
        result?.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });

    backButton?.addEventListener('click', () => {
      if (current <= 0) return;
      current -= 1;
      renderQuestion();
    });

    root.querySelectorAll('[data-analysis-reset]').forEach((button) => {
      button.addEventListener('click', () => {
        reset();
        engineWrap?.scrollIntoView({
          behavior: reducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    form?.addEventListener('submit', submitReport);

    renderQuestion();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbali-store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drbali-store-locator')) return;

    class DrBaliStoreLocator extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('[data-drbali-locator]') || this;
        this.search = this.querySelector('[data-drbali-locator-search]');
        this.clearButton = this.querySelector('[data-drbali-locator-clear]');
        this.cityWrap = this.querySelector('[data-drbali-locator-cities]');
        this.items = [...this.querySelectorAll('[data-drbali-locator-item]')];
        this.details = [...this.querySelectorAll('[data-drbali-locator-detail]')];
        this.empty = this.querySelector('[data-drbali-locator-empty]');

        this.activeCity = 'all';
        this.query = '';
        this.currentIndex = 0;

        this.buildCities();

        this.items.forEach((item, index) => {
          item.addEventListener('click', () => this.select(index));
        });

        this.search?.addEventListener('input', () => {
          this.query = this.normalize(this.search.value);
          if (this.clearButton) this.clearButton.hidden = !this.query;
          this.filter();
        });

        this.clearButton?.addEventListener('click', () => {
          if (!this.search) return;
          this.search.value = '';
          this.query = '';
          this.clearButton.hidden = true;
          this.filter();
          this.search.focus();
        });

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const selected = event.target.closest('[data-drbali-locator-item]');
            if (!selected) return;

            const index = Number(selected.dataset.index);
            if (!Number.isNaN(index)) this.select(index);
          });
        }
      }

      normalize(value) {
        return (value || '')
          .toLocaleLowerCase('tr-TR')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();
      }

      buildCities() {
        if (!this.cityWrap || !this.items.length) return;

        const cities = [
          ...new Set(
            this.items
              .map((item) => item.dataset.city?.trim())
              .filter(Boolean)
          )
        ];

        if (cities.length <= 1) {
          this.cityWrap.hidden = true;
          return;
        }

        const makeButton = (label, value, active = false) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `drbali-locator__city${active ? ' is-active' : ''}`;
          button.textContent = label;
          button.dataset.cityFilter = value;
          button.setAttribute('aria-pressed', active ? 'true' : 'false');

          button.addEventListener('click', () => {
            this.activeCity = value;

            this.cityWrap.querySelectorAll('[data-city-filter]').forEach((candidate) => {
              const isActive = candidate === button;
              candidate.classList.toggle('is-active', isActive);
              candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            this.filter();
          });

          return button;
        };

        this.cityWrap.appendChild(makeButton('Tümü', 'all', true));

        cities.forEach((city) => {
          this.cityWrap.appendChild(makeButton(city, this.normalize(city)));
        });
      }

      filter() {
        let visibleCount = 0;
        let firstVisibleIndex = -1;

        this.items.forEach((item, index) => {
          const city = this.normalize(item.dataset.city);
          const searchText = this.normalize(item.dataset.search);

          const cityMatch =
            this.activeCity === 'all' ||
            city === this.activeCity;

          const queryMatch =
            !this.query ||
            searchText.includes(this.query);

          const visible = cityMatch && queryMatch;
          item.hidden = !visible;

          if (visible) {
            visibleCount += 1;
            if (firstVisibleIndex === -1) firstVisibleIndex = index;
          }
        });

        if (this.empty) this.empty.hidden = visibleCount > 0;

        const currentItem = this.items[this.currentIndex];

        if (
          visibleCount > 0 &&
          (!currentItem || currentItem.hidden)
        ) {
          this.select(firstVisibleIndex);
        }

        if (visibleCount === 0) {
          this.details.forEach((detail) => {
            detail.hidden = true;
            detail.classList.remove('is-active');
          });

          this.items.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
        }
      }

      select(index) {
        if (index < 0 || index >= this.items.length) return;
        if (this.items[index]?.hidden) return;

        this.currentIndex = index;

        this.items.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        this.details.forEach((detail, detailIndex) => {
          const active = detailIndex === index;
          detail.classList.toggle('is-active', active);
          detail.hidden = !active;
        });
      }
    }

    customElements.define('drbali-store-locator', DrBaliStoreLocator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
